"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgFreeMonth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 96,
    viewBox: "0 0 80 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 9h2c7.732 0 14 6.268 14 14v52c0 7.732-6.268 14-14 14H14C6.268 89 0 82.732 0 75V23C0 15.268 6.268 9 14 9h2V4h6v5h36V4h6v5zM22 20v-5h36v5h6v-5h2a8 8 0 018 8v52a8 8 0 01-8 8H14a8 8 0 01-8-8V23a8 8 0 018-8h2v5h6z",
    fill: "url(#freeMonth_svg__freeMonth_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.118 34.762L34.734 64.809 19.596 51.097l4.085-4.511 10.558 9.563 22.305-25.403 4.574 4.016z",
    fill: "url(#freeMonth_svg__freeMonth_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "freeMonth_svg__freeMonth_svg__paint0_linear",
    x1: 100.071,
    y1: 51.007,
    x2: 42.516,
    y2: -16.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: props.color || "#133251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: props.color || "#133251",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "freeMonth_svg__freeMonth_svg__paint1_linear",
    x1: 30.421,
    y1: 20.929,
    x2: 16.414,
    y2: 57.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: props.color || "#133251",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: props.color || "#133251"
  }))));
}

var _default = SvgFreeMonth;
exports["default"] = _default;